<template>
  <div class="product-system">
    <div class="kong">
      <Header></Header>
    </div>
    <div class="img_box"></div>
    <div class="wrap_title">
      <div class="title_box">
        <div class="title">
          <a class="no" href="/">{{ $t("system.home.menu.home") }}</a>
          <text>></text>
          <a class="th">{{ currentTitle }}</a>
        </div>
      </div>
    </div>
    <div class="brand-intro">
      <div class="brand-logo">
        <img src="../../../public/hlp.png" alt="" />
      </div>
      <div class="brand-content">
        <div class="brand-text">
          <p class="intro-text">
            {{ $t('system.brand.intro_text') }}
          </p>
          <p class="intro-detail">
            {{ $t('system.brand.intro_detail') }}
          </p>
        </div>
        <div class="brand-image">
          <img
            src="https://www.tantivy.com/static/images/skoda_02.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 内容区域 -->
    <div class="content-wrapper">
      <!-- 子系统页面内容 hasSystem === 1 -->
      <template v-if="isSubSystem">
        <div class="subsystem-content" v-if="systemLayout === 0">
          <!-- 系统介绍 -->
          <div class="system-intro">
            <div class="intro-text"></div>
          </div>

          <!-- 系统分类 -->
          <div class="system-categories">
            <div class="category-background">
              <div class="category-tabs">
                <div
                  v-for="(category, index) in mainCategories"
                  :key="index"
                  :class="['tab-item', { active: activeTab === index }]"
                  @mouseenter="activeTab = index"
                >
                  <img :src="category.picUrl" alt="" />
                  <h3>
                    {{ getTranslatedText(category.translations, "cname") }}
                  </h3>
                </div>
              </div>
            </div>

            <!-- 添加系统描述部分 -->
            <div class="system-description" v-if="mainCategories[activeTab]">
              <h2 class="description-title">
                {{
                  getTranslatedText(
                    mainCategories[activeTab].translations,
                    "title"
                  )
                }}
              </h2>
              <p class="description-text">
                {{
                  getTranslatedText(
                    mainCategories[activeTab].translations,
                    "intro"
                  )
                }}
              </p>
            </div>
            <!-- 分类下的产品列表 -->
            <div class="category-products" v-if="mainCategories[activeTab]">
              <div class="products-grid">
                <div
                  v-for="product in mainCategories[activeTab].products"
                  :key="product.id"
                  class="product-card"
                  @click="handleProductClick(product)"
                >
                  <div class="product-image">
                    <img :src="product.picUrl" :alt="product.name" />
                    <div class="product-name">
                      {{ getTranslatedText(product.translations, "cname") }}
                    </div>
                    <div class="overlay">
                      <div class="overlay-content">
                        <h3>
                          {{ getTranslatedText(product.translations, "cname") }}
                        </h3>
                        <p>
                          {{ getTranslatedText(product.translations, "intro") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="subsystem-content layout-grid" v-if="systemLayout === 1">
          <div class="system-categories-list">
            <div
              v-for="(category, index) in mainCategories"
              :key="index"
              :class="['category-list-item', { active: activeTab === index }]"
              @mouseenter="activeTab = index"
            >
              <div class="category-info">
                <div class="category-header">
                  <img :src="category.picUrl" alt="" />
                  <div class="header-content">
                    <h3>
                      {{ getTranslatedText(category.translations, "cname") }}
                    </h3>
                    <p>
                      {{ getTranslatedText(category.translations, "intro") }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- 分类下的产品列表 -->
              <div
                class="category-products"
                :class="{ active: activeTab === index }"
              >
                <div class="products-grid">
                  <div
                    v-for="product in category.products"
                    :key="product.id"
                    class="product-card"
                    @click="handleProductClick(product)"
                  >
                    <div class="product-image">
                      <img :src="product.picUrl" :alt="product.name" />
                      <div class="product-name">
                        {{ getTranslatedText(product.translations, "cname") }}
                      </div>
                      <div class="product-info">
                        <h4>
                          {{ getTranslatedText(product.translations, "cname") }}
                        </h4>
                        <p>
                          {{ getTranslatedText(product.translations, "intro") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- 普通菜单页面内容 hasSystem === 0 -->
      <template v-else>
        <div class="menu-content">
          <!-- 当产品数量小于等于3个时，使用Dongtu.vue的布局和动画 -->
          <template v-if="products.length <= 3">
            <div class="dongtu-style">
              <div
                v-for="(product, index) in products"
                :key="product.id"
                class="dongtu-item"
                @click="handleProductClick(product)"
              >
                <div :class="`tu-${index + 1}`">
                  <div class="tu-inner" :class="{ reverse: index % 2 === 0 }">
                    <div
                      class="inner-left"
                      :style="{
                        transform:
                          index % 2 === 0
                            ? leftTransform[`tu-${index + 1}`]
                            : rightTransform[`tu-${index + 1}`],
                      }"
                    >
                      <template v-if="index % 2 === 0">
                        <img :src="product.picUrl" :alt="product.name" />
                      </template>
                      <template v-else>
                        <div class="content-box">
                          <div class="o_right_box">
                            <div class="o_a">
                              {{
                                getTranslatedText(product.translations, "cname")
                              }}
                            </div>
                            <div class="o_b">
                              {{
                                getTranslatedText(product.translations, "intro")
                              }}
                            </div>
                            <div class="d_g">
                              <van-icon class="o_c" name="arrow" />
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div
                      class="inner-right"
                      :style="{
                        transform:
                          index % 2 === 0
                            ? rightTransform[`tu-${index + 1}`]
                            : leftTransform[`tu-${index + 1}`],
                      }"
                    >
                      <template v-if="index % 2 === 0">
                        <div class="content-box">
                          <div class="o_right_box">
                            <div class="o_a">
                              {{
                                getTranslatedText(product.translations, "cname")
                              }}
                            </div>
                            <div class="o_b">
                              {{
                                getTranslatedText(product.translations, "intro")
                              }}
                            </div>
                            <div class="d_g">
                              <van-icon class="o_c" name="arrow" />
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <img :src="product.picUrl" :alt="product.name" />
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- 当产品数量大于3个时，使用网格布局 -->
          <template v-else>
            <div
              class="menu-products-grid"
              :class="{ 'has-center-item': products.length % 2 === 1 }"
            >
              <div
                v-for="(product, index) in products"
                :key="product.id"
                class="menu-product-card fade-in"
                :style="{ animationDelay: `${index * 0.2}s` }"
                :class="{
                  'center-item':
                    index === products.length - 1 && products.length % 2 === 1,
                }"
                @click="handleProductClick(product)"
              >
                <div class="menu-product-info">
                  <h3 class="menu-product-title">
                    {{ getTranslatedText(product.translations, "cname") }}
                  </h3>
                  <p class="menu-product-desc">
                    {{ getTranslatedText(product.translations, "intro") }}
                  </p>
                </div>
                <div class="menu-product-image">
                  <img :src="product.picUrl" :alt="product.name" />
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"></Navbar>
  </div>
</template>

<script setup lang="ts">
import Header from "./../home/repeat/Header.vue";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import Navbar from "../home/repeat/Navbar.vue";
import { ref, onMounted, watch, onUnmounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import axios from "@/utils/axios";
import { useBreadcrumbStore } from "@/stores/breadcrumb";

const breadcrumbStore = useBreadcrumbStore();
const route = useRoute();
const router = useRouter();
const { locale } = useI18n();

// 数据定义
const isSubSystem = ref(false);
const currentTitle = ref("");
const systemTitle = ref("");
const mainCategories = ref([]);
const products = ref([]);
const activeTab = ref(0);
const leftTransform = reactive({});
const rightTransform = reactive({});
const systemLayout = ref(0);

const getTranslatedText = (
  translations: any,
  key: string,
  defaultText: string = ""
) => {
  if (!translations) return defaultText;
  return (
    translations[locale.value]?.[key] ||
    translations["zh-cn"]?.[key] ||
    translations["en"]?.[key] ||
    defaultText
  );
}; // 获取页面数据
const fetchPageData = async () => {
  try {
    const { systemId, menuId, parentId } = route.query;

    if (systemId) {
      // 获取子系统数据
      const response = await axios.get(
        `/framework/product/list/tree/${systemId}`
      );
      if (!response || !Array.isArray(response)) {
        console.error("Invalid response data");
        return;
      }
      // 将数组转换为对象，取第一个元素
      const systemResponse = response[0] || {};
      // 设置布局类型
      systemLayout.value = systemResponse.systemLayout || 0;
      // 设置系统状态和标题
      isSubSystem.value = true;
      currentTitle.value = getTranslatedText(
        systemResponse.translations,
        "cname"
      );
      // 设置系统信息
      systemTitle.value = currentTitle.value;

      // 处理主要分类
      mainCategories.value = (systemResponse.children || []).map(
        (category) => ({
          picUrl: category.picUrl,
          translations: category.translations,
          products: (category.children || []).map((product: any) => ({
            id: product.id,
            picUrl: product.picUrl,
            translations: product.translations,
          })),
        })
      );
    } else {
      // 获取普通菜单数据
      const response = await axios.get(
        `/framework/product/list/tree/${menuId}`
      );
      // 将数组转换为对象，取第一个元素
      const menuResponse = Array.isArray(response) ? response[0] : response;
      // 设置菜单状态和标题
      isSubSystem.value = false;
      currentTitle.value = getTranslatedText(
        menuResponse.translations,
        "cname"
      );
      // 设置产品列表
      products.value = menuResponse.children || [];
    }
  } catch (error) {
    console.error("获取页面数据失败:", error);
  }
};

// 监听路由变化，重新获取数据
watch(
  () => route.query,
  (newQuery) => {
    // 只要 query 发生变化就重新获取数据
    fetchPageData();
  },
  { immediate: true } // 添加 immediate: true 确保首次加载时也执行
);

// 组件挂载时获取数据
onMounted(() => {
  fetchPageData();
  if (products.value.length <= 3) {
    window.addEventListener("scroll", handleScroll);
    handleScroll(); // 初始检查
  }
});

onUnmounted(() => {
  if (products.value.length <= 3) {
    window.removeEventListener("scroll", handleScroll);
  }
});

// 处理产品点击
const handleProductClick = (productType: any) => {
  let breadcrumbs = [];
  const { systemId, menuId, parentId, systemLayout } = route.query;
  if (isSubSystem.value) {
    // 子系统场景：系统 > 分类 > 产品
    breadcrumbs = [
      {
        title: currentTitle.value,
        translations: null,
      },
      {
        title: getTranslatedText(
          mainCategories.value[activeTab.value]?.translations,
          "cname"
        ),
        translations: mainCategories.value[activeTab.value]?.translations,
      },
      {
        title: getTranslatedText(productType.translations, "cname"),
        translations: productType.translations,
      },
    ];
  } else {
    // 普通菜单场景：菜单 > 产品
    breadcrumbs = [
      {
        title: currentTitle.value,
        translations: route.query.translations
          ? JSON.parse(route.query.translations as string)
          : null,
      },
      {
        title: getTranslatedText(productType.translations, "cname"),
        translations: productType.translations,
      },
    ];
  }
  localStorage.setItem("productBreadcrumbs", JSON.stringify(breadcrumbs));

  breadcrumbStore.setBreadcrumbs(breadcrumbs);
  // console.log(breadcrumbStore.breadcrumbs);

  router.push({
    path: "/home/productlist",
    query: {
      cid: productType.id,
      ...(systemId ? { systemId, parentId } : { menuId, parentId }),
      systemLayout,
    },
  });
};

// 处理滚动事件的函数
const handleScroll = () => {
  requestAnimationFrame(() => {
    products.value.forEach((_, index) => {
      const containerElement = document.querySelector(`.tu-${index + 1}`);
      if (containerElement) {
        const containerBounds = containerElement.getBoundingClientRect();
        const containerTop = containerBounds.top + window.scrollY;

        if (
          containerBounds.top <= 0 &&
          (containerBounds.bottom >= window.innerHeight ||
            window.scrollY > containerTop)
        ) {
          leftTransform[`tu-${index + 1}`] = "translateX(50px)";
          rightTransform[`tu-${index + 1}`] = "translateX(-50px)";
        } else {
          leftTransform[`tu-${index + 1}`] = "translateX(0)";
          rightTransform[`tu-${index + 1}`] = "translateX(0)";
        }
      }
    });
  });
};
</script>

<style lang="scss" scoped>
.kong {
  width: 100%;
  height: 120px;
  max-width: 1200px;
  margin: 0 auto;
}
.product-system {
  width: 100%;
  height: auto;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.img_box {
  width: 100%;
  height: 553px;
  position: relative;
  background-image: url("./../../../public/system_img.jpg");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  margin: 0;
  padding: 0;
}

.content-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px;
}
.product-system {
  margin: 0 auto;

  .page-header {
    text-align: center;
    margin-bottom: 40px;

    h1 {
      font-size: 32px;
      color: #333;
      font-weight: 600;
    }
  }

  // 子系统样式
  .subsystem-content {
    .system-intro {
      display: flex;
      gap: 40px;
      margin-bottom: 60px;

      .intro-text {
        flex: 1;

        h2 {
          font-size: 24px;
          color: #004080;
          margin-bottom: 20px;
        }

        p {
          font-size: 16px;
          line-height: 1.6;
          color: #666;
        }
      }

      .system-image {
        flex: 1;

        img {
          width: 100%;
          height: auto;
          border-radius: 8px;
        }
      }
    }

    .system-categories {
      .category-background {
        width: 100vw;
        height: v-bind('mainCategories.length <= 3 ? "40vh" : "80vh"');
        margin-left: calc(-50vw + 50%);
        margin-right: calc(-50vw + 50%);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        &::before {
          content: "";
          position: absolute;
          inset: 0;
          background-image: url("../../assets/imgs/vd_vika01.jpg");
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          z-index: -1; // 将背景置于内容之后
        }
      }
      .category-tabs {
        max-width: 1200px;
        width: 100%;
        padding: 0 20px;
        position: relative;
        z-index: 1;
        display: grid; // 改用 grid 布局
        grid-template-columns: repeat(3, 1fr); // 每行三列
        gap: 15px;

        .tab-item {
          flex: 1;
          // padding: 30px 40px;
          // padding: 20px;
          background: #f8f8f8;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.4s ease;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 10px;
          border: 2px solid transparent;

          img {
            width: 70%;
            height: 150px;
            object-fit: cover;
            // margin-bottom: 15px;
            transition: filter 0.3s ease; // 添加这行，实现平滑过渡
            // filter: brightness(0.8) sepia(0.2) hue-rotate(190deg); // 默认图片滤镜
          }

          &:hover {
            background: transparent; // 改为完全透明
            color: white;
            border: 2px solid rgba(255, 255, 255, 0.8); // 添加白色边框
            transform: translateY(-2px); // 添加轻微上浮效果
            // img {
            //   filter: brightness(1) sepia(0) hue-rotate(0); // 悬浮时白色
            // }
          }

          &.active {
            background: transparent; // 改为完全透明
            color: white;
            border: 2px solid rgba(255, 255, 255, 0.8); // 添加白色边框
            // img {
            //   filter: brightness(1) sepia(0) hue-rotate(0); // 选中时白色，与悬浮状态一致
            // }
            p {
              color: #fff;
              transition: color 0.4s ease; // 文字颜色过渡
            }
          }

          h3 {
            font-size: 18px;
            margin-top: 10px; // 添加上边距
            letter-spacing: 3px; // 添加字间距
          }

          p {
            font-size: 14px;
            color: #666;
            line-height: 1.5;
          }
        }
      }
    }
  }
}

.system-categories {
  .category-tabs {
    display: flex;
    gap: 20px;

    .tab-item {
      flex: 1;
      padding: 20px;
      background: #f8f8f8;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.4s ease;
      text-align: center;

      img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        margin-bottom: 15px;
      }

      h3 {
        font-size: 18px;
        margin-bottom: 10px;
      }

      &:hover {
        transform: translateY(-2px);
      }

      &.active {
        background: #004080;
        color: white;
      }
    }
  }

  // 添加系统描述样式
  .system-description {
    text-align: center;
    padding: 40px 0;
    max-width: 800px;
    margin: 0 auto;
    position: relative;

    .description-title {
      font-size: 28px;
      color: #004080;
      margin-bottom: 20px;
      font-weight: 600;
    }

    .description-text {
      font-size: 18px;
      line-height: 1.8;
      color: #666;
      margin: 0 auto;
    }
  }

  .category-products {
    padding: 0 100px;
    .products-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 30px;

      .product-card {
        position: relative;
        border: 1px solid #eee;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        background: white;
        opacity: 0;
        transform: translateY(-20px);
        animation: slideDown 0.6s ease forwards;

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        // 为每个卡片设置不同的动画延迟
        @for $i from 1 through 9 {
          &:nth-child(#{$i}) {
            animation-delay: #{$i * 0.1}s;
          }
        }

        .product-image {
          position: relative;
          height: 300px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
          }

          .product-name {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 40px;
            line-height: 40px;
            background: rgba(0, 64, 128, 0.9);
            text-align: center;
            font-size: 24px;
            color: white;
            font-weight: 500;
            transition: all 0.4s ease;
            z-index: 2;
          }

          .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: calc(100% - 40px);
            background: rgba(0, 64, 128, 0.9);
            transform: translateY(-100%);
            transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 30px 0;
            z-index: 1;
            .overlay-content {
              color: white;
              text-align: center;
              opacity: 0;
              transform: translateY(20px);
              transition: all 0.4s ease 0.2s;
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              h3 {
                font-size: 24px;
                font-weight: 600;
                margin-bottom: 15px;
                color: #fff;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
              }

              p {
                font-size: 16px;
                line-height: 1.6;
                color: rgba(255, 255, 255, 0.9);
                margin: 0 auto;
                max-width: 80%;
                overflow-wrap: break-word;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 5; // 显示5行
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }

        &:hover {
          .product-image {
            img {
              transform: scale(1.1);
            }

            .product-name {
              opacity: 0;
              transform: translateY(100%);
            }

            .overlay {
              transform: translateY(0);

              .overlay-content {
                opacity: 1;
                transform: translateY(0);
              }
            }
          }
        }
      }
    }
  }
}
.menu-content {
  padding: 40px 0;
}

// Dongtu样式（小于等于3个产品时的样式）
.dongtu-style {
  width: 100%;

  .dongtu-item {
    width: 100%;
    height: 600px;
    margin-bottom: 40px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .tu-inner {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 1200px;
    height: 600px;
    margin: 0 auto;
    padding: 0 15px;

    &.reverse {
      position: relative;
      background-color: #f0f0f0;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100vw;
        height: 100%;
        background-color: #f0f0f0;
        z-index: -1;
      }
    }
  }

  .inner-left,
  .inner-right {
    position: relative;
    width: 600px;
    height: 600px;
    display: flex;
    align-items: center;
    transition: transform 1s ease;

    img {
      width: 600px;
      height: 600px;
      object-fit: cover;
    }
  }

  .content-box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .o_right_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: auto;
    min-height: 200px;
    padding: 0 60px;
  }

  .o_a {
    font-size: 50px;
    color: #004080;
    line-height: 1.1;
    margin-bottom: 30px;
    transition: color 0.6s ease;
  }

  .o_b {
    font-size: 20px;
    color: #3e3a39;
    line-height: 26px;
    margin-bottom: 30px;
  }

  .d_g {
    width: 65px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    border: 2px #004080 solid;
    border-radius: 5px;
    font-size: 20px;
    cursor: pointer;
    transition: all 0.3s ease;

    .o_c {
      color: #004080;
      transition: color 0.3s ease;
    }

    &:hover {
      background-color: #004080;
      .o_c {
        color: #fff;
      }
    }
  }
}

// 网格布局样式（大于3个产品时的样式）
.menu-products-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  &.has-center-item {
    .center-item {
      grid-column: 1 / -1;
      width: 50%;
      margin: 0 auto;
    }
  }
}

.menu-product-card {
  background: #f5f5f5;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  opacity: 0;
  animation: fadeInUp 0.8s ease forwards;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 64, 128, 0.1);

    .menu-product-image {
      img {
        transform: scale(1.05);
      }
    }

    .menu-product-info {
      .menu-product-title {
        color: darken(#004080, 10%);
      }
    }
  }

  .menu-product-image {
    width: 100%;
    margin-top: 30px;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
      object-fit: contain;
      transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }

  .menu-product-info {
    text-align: center;
    width: 100%;
    transition: all 0.3s ease;

    .menu-product-title {
      font-size: 24px;
      color: #004080;
      margin-bottom: 25px;
      font-weight: 500;
      transition: color 0.3s ease;
    }

    .menu-product-desc {
      font-size: 16px;
      color: #666;
      max-width: 80%;
      margin: 0 auto;
    }
  }
}

.menu-product-image {
  width: 100%;
  margin-top: 30px;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}

.menu-product-info {
  text-align: center;
  width: 100%;
}

.menu-product-title {
  font-size: 24px;
  color: #004080;
  margin-bottom: 25px;
  font-weight: 500;
}

.menu-product-desc {
  font-size: 16px;
  color: #666;
  max-width: 80%;
  margin: 0 auto;
}

.wrap_title {
  padding: 30px 0;
  width: 100%;
  color: #3e3a39;
  font-size: 14px;
  height: 26px;
}

.title_box {
  width: 100%;
  max-width: 1230px;
  padding: 0 15px;
  margin: 0 auto;
  box-sizing: border-box;
}
.title {
  width: 100%;
  height: 100%;
  font-size: 18px;
  margin: 0 -8px;
}
.title a {
  display: inline-block;
  padding: 0 8px;
  font-weight: bold;
  color: #696b71;
}
.subsystem-content.layout-grid {
  padding: 60px 0;

  .system-categories-list {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;

    .category-list-item {
      margin-bottom: 80px;
      background: #fff;
      border: 1px solid #eee;
      transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1); // 调整整体过渡时间和缓动函数

      // 鼠标悬浮效果
      &:hover {
        .category-header {
          background: #004080;
          transition: background-color 0.6s ease; // 背景
          .header-content {
            h3 {
              color: white;
              transform: translateY(-2px);
            }
            p {
              color: rgba(255, 255, 255, 0.9);
            }
          }

          img {
            transform: scale(1.05);
            border-color: rgba(255, 255, 255, 0.2);
            // filter: brightness(1) sepia(0) hue-rotate(0); // 选中时白色，与悬浮状态一致
            transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
          }
        }

        .category-products {
          display: block;
          opacity: 1;
          transform: translateY(0);
          visibility: visible;
          transition: all 1s cubic-bezier(0.4, 0, 0.2, 1);
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
      .category-header {
        padding: 40px 60px;
        display: flex;
        align-items: center;
        gap: 50px;
        transition: all 0.5s ease;
        transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        img {
          width: 140px;
          height: 140px;
          object-fit: cover;
          border-radius: 50%;
          border: 4px solid rgba(0, 64, 128, 0.1);
          transition: all 0.5s ease;
          // filter: brightness(0.8) sepia(0.2) hue-rotate(190deg); // 默认图片滤镜
          transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .header-content {
          flex: 1;

          h3 {
            font-size: 36px;
            color: #004080;
            margin-bottom: 20px;
            transition: all 0.4s ease;
            font-weight: 600;
            letter-spacing: -0.5px;
          }

          p {
            font-size: 16px;
            color: #666;
            line-height: 1.8;
            transition: all 0.4s ease;
            max-width: 800px;
          }
          .header-content {
            h3,
            p {
              transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1); // 调整文字过渡
            }
          }
        }
      }
      &:hover {
        .category-products {
          max-height: 2000px;
          opacity: 1;
          transform: translateY(0);
          padding: 50px;

          .products-grid {
            opacity: 1;
            transform: translateY(0);
            transition-delay: 0.2s;
          }
        }
      }
      .category-products {
        max-height: 0;
        opacity: 0;
        overflow: hidden;
        background: #fafafa;
        transform: translateY(-20px);
        transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        border-top: 1px solid #eee;
        padding: 0;

        .products-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;
          opacity: 0;
          transform: translateY(20px);
          transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);

          .product-card {
            position: relative;
            overflow: hidden;
            background: white;
            border-radius: 12px;
            box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
            transition: all 0.4s ease;

            &:hover {
              transform: translateY(-5px);
              box-shadow: 0 8px 25px rgba(0, 64, 128, 0.12);

              .product-image {
                img {
                  transform: scale(1.08);
                }

                .product-name {
                  opacity: 0;
                  transform: translateY(100%);
                }

                .product-info {
                  opacity: 1;
                  visibility: visible;
                  transform: translateY(0);
                }
              }
            }

            .product-image {
              position: relative;
              height: 260px;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
              }

              .product-name {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                padding: 15px 0;
                background: rgba(255, 255, 255, 0.95);
                color: #004080;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                transition: all 0.4s ease;
                backdrop-filter: blur(5px);
              }

              .product-info {
                position: absolute;
                inset: 0;
                padding: 30px;
                background: linear-gradient(
                  to top,
                  rgba(0, 64, 128, 0.85),
                  rgba(0, 64, 128, 0.85)
                );
                backdrop-filter: blur(3px); // 减小模糊程度
                color: white;
                opacity: 0;
                visibility: hidden;
                transition: all 0.4s ease;
                display: flex;
                flex-direction: column;
                justify-content: center;
                transform: translateY(10px);
                backdrop-filter: blur(5px);

                h4 {
                  font-size: 22px;
                  font-weight: 600;
                  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                  margin: 0 0 15px 0;
                }

                p {
                  font-size: 15px;
                  line-height: 1.6;
                  opacity: 0.95;
                  overflow-wrap: break-word;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 5; // 显示5行
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.brand-intro {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  // padding: 60px 40px;

  .brand-logo {
    margin-bottom: 60px;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: -30px;
      left: 0; // 修改这里，从50%改为0
      width: 80%;
      height: 2px;
      background: #e0e0e0;
    }

    img {
      max-width: 100%;
      height: auto;
    }
  }

  .brand-content {
    display: flex;
    gap: 60px;
    align-items: flex-start;
    padding: 0 40px;

    .brand-text {
      flex: 1;
      position: relative;

      .intro-text {
        font-size: 18px;
        color: #333;
        line-height: 1.8;
        margin-bottom: 30px;
      }

      .intro-detail {
        font-size: 18px;
        color: #666;
        line-height: 1.8;
      }
    }

    .brand-image {
      flex: 1;

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }
}
</style>